import { render, staticRenderFns } from "./ChangeInfo.vue?vue&type=template&id=675e3ae4&scoped=true&"
import script from "./ChangeInfo.vue?vue&type=script&lang=js&"
export * from "./ChangeInfo.vue?vue&type=script&lang=js&"
import style0 from "./ChangeInfo.vue?vue&type=style&index=0&id=675e3ae4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675e3ae4",
  null
  
)

export default component.exports